module.exports = __webpack_public_path__ + "static/Carly_Daniel15-263ac8139d9bd9e9c17341aa21757fae.jpg";